import Logout from '@mui/icons-material/Logout'
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined'
import { Box, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material'
import { useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { useLocation, useNavigate } from 'react-router-dom'
import { PROFILE_ROUTE, TERMS_OF_USE_ROUTE } from '../../../constants/routing.constants'
import { useNotificationsStore } from '../../../store/storeNotifications'
import { useWrapperStore } from '../../../store/storeWrapper'
import { SidebarType } from '../../../types/sidebars'
import { NotificationsBadge } from '../../NotificationsBadge/NotificationsBadge'
import { ProfileButton } from '../../ProfileButton'
import BellIcon from './../../../assets/icons/Bell.svg'
import GearIcon from './../../../assets/icons/Gear.svg'
import NewFileIcon from './../../../assets/icons/NewFile.svg'

export const DesktopHeaderActions = ({ disabled }) => {
    const auth = useAuth()
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { setOpenSidebarType, openSidebarType } = useWrapperStore((state) => state)
    const { numberOfUnreadNotifications } = useNotificationsStore((state) => state)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        auth.signoutRedirect()
    }

    const handleToggleNotificationsSidebar = () => {
        setOpenSidebarType(
            openSidebarType === SidebarType.NOTIFICATIONS ? null : SidebarType.NOTIFICATIONS,
        )
    }

    return (
        <Box gap={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Глобальные настройки моделей">
                <IconButton
                    disabled={disabled}
                    onClick={() => navigate(`/setting`)}
                    size="large"
                    sx={{
                        pointerEvents: pathname === `/setting` ? 'none' : 'auto',
                        color: '#5A5F72',
                        background: '#ffffff',
                    }}>
                    <GearIcon />
                </IconButton>
            </Tooltip>
            <Tooltip
                title="Уведомления и события ARHIASSISTANT"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: '350px',
                        },
                    },
                }}
                placement="bottom-end">
                <IconButton
                    disabled={disabled}
                    onClick={handleToggleNotificationsSidebar}
                    size="large"
                    sx={{
                        color: '#5A5F72',
                        background: '#ffffff',
                    }}>
                    <NotificationsBadge
                        count={numberOfUnreadNotifications}
                        showZero={false}
                        disabled={disabled}>
                        <BellIcon />
                    </NotificationsBadge>
                </IconButton>
            </Tooltip>

            <Tooltip title="Данные пользователя">
                <ProfileButton
                    sx={{
                        opacity: disabled ? '0.3' : '1',
                    }}
                    disabled={disabled}
                    onClick={handleClick}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                />
            </Tooltip>
            <Menu
                disabled={disabled}
                sx={{ width: '400px' }}
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                <MenuItem
                    onClick={() => navigate(PROFILE_ROUTE)}
                    sx={{ justifyContent: 'space-between' }}>
                    Профиль
                    <ListItemIcon sx={{ ml: 2 }}>
                        <Person2OutlinedIcon />
                    </ListItemIcon>
                </MenuItem>
                <MenuItem
                    onClick={() => navigate(TERMS_OF_USE_ROUTE)}
                    sx={{ justifyContent: 'space-between' }}>
                    Условия использования
                    <ListItemIcon sx={{ ml: 2 }}>
                        <NewFileIcon />
                    </ListItemIcon>
                </MenuItem>
                <MenuItem onClick={() => handleLogout()} sx={{ justifyContent: 'space-between' }}>
                    Выйти из аккаунта
                    <ListItemIcon sx={{ ml: 2 }}>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                </MenuItem>
            </Menu>
        </Box>
    )
}
